import { t as e } from "../utils-DiFe-_ei.js";
import * as t from "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/foundations/input/input.tsx
var r = t.forwardRef(({ className: t, type: r, ...i }, a) => /* @__PURE__ */ n("input", {
	type: r,
	className: e("flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", t),
	ref: a,
	...i
}));
r.displayName = "Input";
//#endregion
export { r as Input };

//# sourceMappingURL=input.js.map